var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWithdrawalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    transform: "rotate(-180 21 21)",
    fill: "#FF0000",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6984 24.5163C29.5258 24.6889 29.2897 24.7979 29.0172 24.7979C28.4904 24.7979 28.0544 24.3619 28.0544 23.8351L28.0544 13.7713L17.9907 13.7714C17.4639 13.7714 17.0279 13.3354 17.0279 12.8086C17.0279 12.2818 17.4639 11.8458 17.9907 11.8458L29.0172 11.8458C29.544 11.8458 29.98 12.2818 29.98 12.8086L29.98 23.8351C29.98 24.1076 29.871 24.3437 29.6984 24.5163Z",
    fill: "#262832"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5448 13.6449L14.2585 28.9312C13.8861 29.3036 13.2684 29.3036 12.8961 28.9312C12.5237 28.5588 12.5237 27.9412 12.8961 27.5688L28.1824 12.2824C28.5548 11.91 29.1724 11.91 29.5448 12.2824C29.9172 12.6548 29.9172 13.2725 29.5448 13.6449Z",
    fill: "#262832"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdrawalIcon);
export default __webpack_public_path__ + "static/media/withdrawal-icon.e8d487945328038bc45ebeba6222e6b5.svg";
export { ForwardRef as ReactComponent };